import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Button from 'react-bootstrap/Button';

import aboutIllustration from '../../assets/illustration.svg'; 


export default function Features() {
  // Feature checkboxes array matching your image lists
  // const featureList = [
  //   "E-commerce & Retail",
  //   "Mobile & Web Apps",
  //   "Enterprise Systems",
  //   "Education & E-Learning"
  // ];

  return (
    <>
      

      {/* SECTION 2: Well Designed Dashboards Layout */}
      <section className="py-5 bg-white">
        <Container className="py-5">
          <Row className="align-items-center g-5">
            
            {/* Left Column: Text & Features List */}
            <Col lg={6}>
              <h6 className="font-rozha display-6 fw-bold mb-3 text-success text-uppercase fw-bold mb-2 small" style={{ letterSpacing: '1px' }}>
                PORTFOLIO
              </h6>
              <h2 className="fw-bold text-dark display-6 mb-4">
                What we do
              </h2>
              <p className="text-secondary lh-lg mb-4 fs-6" style={{ maxWidth: '500px' }}>
                At TSM Pvt. Ltd, we take pride in crafting technology solutions that drive real business value. Our portfolio spans multiple industries, showcasing a blend of technical expertise, creativity, and strategic insight. Here are some highlights of our recent work
              <br />
              <br />
                We are committed to your success. TSM Pvt. Ltd combines technical expertise with deep industry knowledge to deliver IT solutions that align perfectly with your business needs. We prioritize clear communication, timely delivery, and continuous improvement to exceed your expectations.
              </p>


              {/* for future use */}

              {/* Responsive Checkbox Grid (2 Columns) */}
              {/* <Row className="mb-5 g-3">
                {featureList.map((feature, index) => (
                  <Col xs={6} key={index}>
                    <div className="d-flex align-items-center">
                      <div 
                        className="d-flex align-items-center justify-content-center rounded-circle me-2" 
                        style={{ backgroundColor: '#daf4f0', width: '24px', height: '24px' }}
                      >
                        <i className="bi bi-check text-success fw-bold fs-5"></i>
                      </div>
                      <span className="fw-semibold text-dark fs-6">{feature}</span>
                    </div>
                  </Col>
                ))}
              </Row> */}

              {/* Action Button */}
              {/* <Button 
                style={{ backgroundColor: '#405189', borderColor: '#405189' }} 
                className="px-4 py-2.5 fw-medium shadow-sm d-inline-flex align-items-center"
              >
                Learn More <span className="ms-2">→</span>
              </Button> */}

            {/* for future use */}

            </Col>

            {/* Right Column: Dashboard Mockups Image */}
            <Col lg={6} className="text-center">
              <img 
                src={aboutIllustration} 
                alt="Dashboard Mockups Showcase" 
                className="img-fluid"
                style={{ maxHeight: '420px', objectFit: 'contain' }}
              />
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
}
